import SearchResultsAccordionFacets from './SearchResultsAccordionFacets.js';
export default SearchResultsAccordionFacets;
